import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import { LanguageProvider } from "./LanguageContext";
import Navbar from "./components/Navbar";
import ScrollToTop from "./ScrollToTop";
import ScrollNav from "./components/ScrollNav";
import CookieConsent from "./components/CookieConsent";

import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import PlatformPage from "./pages/PlatformPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import DashboardLogin from "./pages/DashboardLogin";
import Dashboard from "./pages/Dashboard";

import { setDefaultConsent, trackPageView } from "./utils/analytics";
import useScrollDepthTracking from "./useScrollDepthTracking";

import "./styles/base.css";
import "./components/Navbar.css";
import "./components/Hero.css";
import "./components/Features.css";
import "./components/Stats.css";
import "./components/Workflow.css";
import "./components/ProductShowcase.css";
import "./components/Contact.css";
import "./components/Footer.css";
import "./components/About.css";
import "./pages/LegalPage.css";
import "./components/CoreValues.css";
import "./components/ScrollNav.css";
import "./components/DataSecurity.css";

function HomeScrollNav() {
  const location = useLocation();
  return location.pathname === "/" ? <ScrollNav /> : null;
}

// The public marketing site — Navbar, cookie banner, scroll tracking, etc.
// all apply here. The internal dashboard (below) is intentionally excluded
// from this shell: no public Navbar link, no GA4 self-tracking of the
// dashboard's own usage, no cookie banner on an internal tool.
function PublicSite() {
  const location = useLocation();
  const isAbout = location.pathname === "/about";

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  useScrollDepthTracking();

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <HomeScrollNav />
      <div
        key={location.pathname}
        className="page-enter"
        style={isAbout
          ? {}
          : { minHeight: '100vh', display: 'flex', flexDirection: 'column' }
        }
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/platform" element={<PlatformPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        </Routes>
      </div>
      <CookieConsent />
    </>
  );
}

function App() {
  useEffect(() => {
    setDefaultConsent();
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <Routes>
          {/* Internal dashboard — no Navbar, no cookie banner, no public GA4
              page tracking. Protected server-side via httpOnly cookie. */}
          <Route path="/internal/login" element={<DashboardLogin />} />
          <Route path="/internal/dashboard" element={<Dashboard />} />

          {/* Everything else goes through the public site shell */}
          <Route path="/*" element={<PublicSite />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
